import React, {
  createContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
} from 'react'
import PropTypes from 'prop-types'
import { sendEvent } from './TealiumUtils'
export const AnalyticsContext = createContext()
export const ANALYTIC_EVENT_LISTENER_NAME = 'analytic-event'

export const AnalyticsProvider = ({
  children,
  analyticService,
  addListener,
  sendEvent,
  removeListener,
}) => {
  const [events, setEvents] = useState([])
  const [service, setService] = useState(analyticService)
  const pushEvent = useCallback(
    (event) => {
      if (
        event &&
        event.data &&
        event.data.eventId === ANALYTIC_EVENT_LISTENER_NAME
      ) {
        service
          ? sendEvent(service, event.data.eventData)
          : setEvents([...events, event.data.eventData])
      }
    },
    [events.length, events, service]
  )

  useEffect(() => {
    if (service && events.length > 0) {
      events.forEach((event) => sendEvent(service, event))
      setEvents([])
    }
  }, [events.length, events, service])

  useEffect(() => {
    addListener('message', pushEvent)
    return () => {
      removeListener('message', pushEvent)
    }
  }, [])

  const contextValue = useMemo(
    () => ({
      pushEvent,
      setService,
    }),
    [pushEvent]
  )

  return (
    <AnalyticsContext.Provider value={contextValue}>
      {children}
    </AnalyticsContext.Provider>
  )
}

AnalyticsProvider.propTypes = {
  children: PropTypes.node,
  analyticService: PropTypes.any,
  addListener: PropTypes.func,
  removeListener: PropTypes.func,
  sendEvent: PropTypes.func,
}

AnalyticsProvider.defaultProps = {
  sendEvent: sendEvent,
  /* istanbul ignore next */
  addListener: window && window.addEventListener,
  /* istanbul ignore next  */
  removeListener: window && window.removeEventListener,
}
